import request from '../../axios/axiosconfig.js'

/**
 * 查询商户列表
 * @param {*} params 
 * @returns 
 */
export function getAllBsList(params) {
  return request({
    url: '/ps/bsStoreRelation/getAllBusiness',
    method: 'get',
    params: params
  })
}

/**
 * 查询商户关系详情
 * @param {*} params 
 * @returns 
 */
export function getBsRelationById(params) {
  return request({
    url: '/ps/bsStoreRelation/getRelationByBsId/'+params,
    method: 'get'
  })
}

/**
 * 添加商户
 * @param {*} params 
 * @returns 
 */
 export function addBsAccount(params) {
  return request({
    url: '/ps/bsStoreRelation/addBsAccount',
    method: 'post',
    data: params
  })
}

/**
 * 操作账户
 * @param {*} params 
 * @returns 
 */
 export function operationAccount(params) {
  return request({
    url: '/ps/bsStoreRelation/operationAccount',
    method: 'post',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/api/relation/businessstorerelation.js